/* =============================================================
   VAIRO 360° VIEWER — Estática a HD Directo + Anti-Swipe
   (vairo-360-motor.js)
============================================================= */

(function () {
  'use strict';

  /* ===========================================================
     PASO 1: BUSCAR EL CONTENEDOR DEL VISOR EN EL DOM
  =========================================================== */
  const container = document.getElementById('vairo-360-viewer');

  if (!container) {
    return;
  }

  /* ===========================================================
     PASO 2: LEER LA CONFIGURACIÓN (Solo HD)
  =========================================================== */
  const config = {
    sheetHd:     container.dataset.sheetHd,
    frameWidth:  parseInt(container.dataset.frameWidth, 10)  || 800,
    frameHeight: parseInt(container.dataset.frameHeight, 10) || 800,
    frames:      parseInt(container.dataset.frames, 10)      || 40,
    framesX:     parseInt(container.dataset.framesX, 10)     || parseInt(container.dataset.frames, 10) || 40
  };

  var $viewer = window.jQuery(container);

  /* ===========================================================
     PASO 3: DESCARGAR EL HD EN SEGUNDO PLANO
  =========================================================== */
  console.log('[Vairo 360°] 📥 Descargando HD en segundo plano...');

  var hdImage = new Image();

  hdImage.onload = function () {
    console.log('[Vairo 360°] ✅ HD descargado. Iniciando motor...');

    // 1. Ocultamos el póster estático de Shopify
    var posterImage = document.getElementById('vairo-360-poster');
    if (posterImage) {
      posterImage.style.display = 'none';
    }

    // 2. Ocultamos el póster de la vista en grilla (mobile) si existe
    var posterGrid = document.getElementById('vairo-360-poster-grid');
    if (posterGrid) {
      posterGrid.style.display = 'none';
    }

    // 3. Parche de optimización para el Canvas
    var canvas = container.querySelector('canvas');
    if (canvas && !canvas.__patched) {
      canvas.getContext('2d', { willReadFrequently: true });
      canvas.__patched = true;
    }

    /* ===========================================================
       PASO 4: INICIALIZAR SPRITESPIN DIRECTAMENTE EN HD
    =========================================================== */
    $viewer.spritespin({
      source: config.sheetHd,
      width: config.frameWidth,
      height: config.frameHeight,
      frames: config.frames,
      framesX: config.framesX,
      plugins: ['360', 'drag', 'ease'],
      animate: true,       // Gira solo al principio
      reverse: true,
      loop: true,
      responsive: true,
      
      // --- TUS VALORES DE FÍSICA INICIAL (EXHIBICIÓN) INTACTOS ---
      frameTime: 85,      
      sense: -0.5,         
      easeDamping: 0.5,   
      easeMaxSamples: 3
      // -----------------------------------------------------------
    });
  };

  hdImage.onerror = function () {
    console.warn('[Vairo 360°] ⚠️ Error al cargar el SpriteSheet HD.');
  };

  // Disparamos la descarga
  hdImage.src = config.sheetHd;

  /* ===========================================================
     PASO 5: DETENER AUTO-ROTACIÓN Y CAMBIAR MARCHAS
  =========================================================== */
  function stopAutoRotate() {
    
    var api = $viewer.spritespin('api');
    if(api) {
      // --- LA MAGIA: Cambio de marchas directo en memoria ---
      // Inyectamos la velocidad interactiva directamente a los datos
      // para evitar que el plugin se reinicie y corte el primer drag.
      api.data.frameTime = 10;
      api.stopAnimation();
    }

    // Ocultar el cartel "Arrastra 360"
    var hint = document.getElementById('vairo-hint-overlay');
    if (hint) {
      hint.style.display = 'none';
    }

    container.removeEventListener('mousedown', stopAutoRotate);
    container.removeEventListener('touchstart', stopAutoRotate);
    console.log('[Vairo 360°] 🛑 Auto-rotación detenida. Modo interactivo activo.');
  }

  container.addEventListener('mousedown', stopAutoRotate);
  container.addEventListener('touchstart', stopAutoRotate, { passive: true });

  /* ===========================================================
     PASO 6: ARREGLAR CONFLICTO CON CAROUSEL DE SHOPIFY
  =========================================================== */
  $viewer.on('mousedown touchstart mousemove touchmove click', function(e) {
    // Evita que la galería cambie de foto al girar el casco
    e.stopPropagation();
  });

})();